import React from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";

import CoreComponent20 from "../../../assets/Sub-component/CoreComponent20";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import Enterpertises2 from "../../../assets/Sub-component/Enterpertises2";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import cost from "../../../assets/Flutter/Scalable-solution/Costeffective.svg";
import deploy from "../../../assets/Flutter/Scalable-solution/Deployment.svg";
import solution from "../../../assets/Flutter/Scalable-solution/Solution.svg";
import culture from "../../../assets/Flutter/Scalable-solution/working culture.svg";
import expert_flutter from "../../../assets/Flutter/Scalable-solution/Specialised_fluter_app.svg";

import dynamic from "../../../assets/Services/Web_design/Offer_custamizable/Dynamic_web.svg";
import resposnsive from "../../../assets/Services/Web_design/Offer_custamizable/Responsive_web.svg";
import WebDesigns from "../../../assets/Services/Web_design/Offer_custamizable/Web_design.svg";



import CoreComponent14 from "../../../assets/Sub-component/CoreComponent14";
import WebDesignCore from "../../../assets/Sub-component/WebDesignCore";
import { Link } from "react-router-dom";

import Admin from '../../../assets/Services/Ruby_on_rails2/Experience_Raiden’s_Ruby/Administration.svg'
import Effective from '../../../assets/Services/Ruby_on_rails2/Experience_Raiden’s_Ruby/Effective.svg'
import Excellence from '../../../assets/Services/Ruby_on_rails2/Experience_Raiden’s_Ruby/Excellence.svg'
import Highly_Secure from '../../../assets/Services/Ruby_on_rails2/Experience_Raiden’s_Ruby/Highly_Secure.svg'
import Portability from '../../../assets/Services/Ruby_on_rails2/Experience_Raiden’s_Ruby/Portability.svg'
import Stability from '../../../assets/Services/Ruby_on_rails2/Experience_Raiden’s_Ruby/Stability.svg'

import customization from '../../../assets/Services/Ruby_on_Rails_website_Design/Customization.svg'
import commerce_Development from '../../../assets/Services/Ruby_on_Rails_website_Design/E-commerce_Development.svg'
import Plugin_Development from '../../../assets/Services/Ruby_on_Rails_website_Design/Plugin_Development.svg'
import Portal_Development from '../../../assets/Services/Ruby_on_Rails_website_Design/Portal_Development.svg'
import UX_Development from '../../../assets/Services/Ruby_on_Rails_website_Design/UX_Development.svg'
import Web_Application from '../../../assets/Services/Ruby_on_Rails_website_Design/Web_Application.svg'
import launchingimage from '../../../assets/Launchingimage.png'
import icon from '../../../assets/Services/Ruby_on_Rails_website_Design/img.png'
import FaqHome from "../../../components/faq/FaqHome";

const RubyONRailsdevelopment = () => {
  const vertical = [
    {
      icon: Portability,
      title: "Portability ",
      line: "line-hori",
    },
    {
      icon: Excellence,
      title: "Excellence",
      line: "line-hori",
    },
    {
      icon: Stability,
      title: "Stability",
      line: "line-hori",
    },
    {
      icon: Effective,
      title: "Effectiveness ",
      line: "line-hori",
    },
    {
      icon: Admin,
      title: "Administration",
      line: "line-hori",
    },

    {
      icon: Highly_Secure,
      title: "Highly Secure",
    },
  ];

  const content100 = [
    {
      icon: customization,
      title: "Ruby on Rails Customization",
      desc: "Our customization allows you to achieve a result that meets both your idea and your company's requirements for creating a benchmark website impression.",
    },
    {
      icon: commerce_Development,
      title: "Web Application Development",
      desc: "Improve your productivity with a visually stunning web ecosystem that offers manageable workflows while reducing the need for extensive configuration.  ",
    },
    {
      icon: Plugin_Development,
      title: "Plugin Development",
      desc: "Plugin development has evolved with our Ruby on Rails development services; we even involve modern approaches related to the Rails engines.",
    },
    {
      icon: Portal_Development,
      title: "Ruby on Rails Portal Development",
      desc: "Our Ruby on Rails developers create a portal that allows you to access multiple pieces of information from various sources in one location on your website.",
    },
    {
      icon: UX_Development,
      title: "Ruby on Rails E-commerce Development",
      desc: "We adapt to new technologies such as AI and AR visuals for products, transforming your e-commerce space into a complete digital storefront for customers.",
    },
    {
      icon: Web_Application,
      title: "Ruby on Rails UI/UX Development",
      desc: "Creating a user interface (UI/UX) for an app that is visually appealing, intuitive, effective, and facilitates customers' navigation of your business product.",
    },
  ];

  const content = [
    {
      icon: expert_flutter,
      title: "Accelerated Development",
      desc: "Utilizing advanced generators and agile methodologies, we make sure to provide a website that minimizes your time and stands unique among your competitors",
      space: true,
    },
    {
      icon: cost,
      title: "Global Reach",
      desc: "Raiden ensures Ruby on Rails provides global reach, where you can effortlessly handle various users across the world.",
      space: true,
    },
    {
      icon: solution,
      title: "Unyielding Data Integrity",
      desc: "Safeguard your valuable digital assets by implementing powerful Ruby on Rails with active record validations and make your app reliable and trustworthy.",
      space: false,
    },
    {
      icon: culture,
      title: "Security ",
      desc: "Raiden offers proactive auditing and a secure experience for your company, preventing the system from running into serious risks.",
      space: false,
    },
    {
      icon: deploy,
      title: "Standards",
      desc: "Providing a precise, predictable, and well-established codebase for presenting a scalable application for your business.",
      space: false,
    },
  ];

  return (
    <>
    <img 
  src={launchingimage} 
  className="Bg-image"
  alt="Launching"
/>

    <div className="main-page-wrapper">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div
        className=" container d-flex align-items-center justify-content-center flex-column height-vh topheader-margin "

      >
        <h1 className="h1-heading lh-sm fw-bold text-center">
          Ruby on Rails Development
        </h1>
        {/* <p className="fw-semibold mt-2 h1-para lh-base text-center">
          {" "}
          code | dot | sjf | dsfs
        </p> */}
        <p className="text-center mt-4 mb-4 h1-para lh-base">
          Experience Raiden's 10 years of expertise in our commitment to
          providing an efficient website and maintaining it with 100%
          satisfaction for your business. We are a
          Ruby on Rails development company that focuses on delivering value through convention and effective
          communication.
        </p>
        <div className="d-flex ">
          <Link to="/request-quote">
            <button className="h1-para mt-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
              Get Your Free Quote
            </button>
          </Link>
        </div>
      </div>

      <div className=" bg-light">
        <div className=" container pt-50 pb-50">
          <div className=" row mb-80 marb">
            <h2 className="col-lg-6  h2-heading lh-sm mb-3 mb-lg-0">
              Ruby on Rails Website Design & Development
            </h2>
            <p className="col-lg-6 h1-para lh-base">
              A well-established website allocates a unique space in this
              digital ecosystem; Raiden works beyond the digital and
              proficiently creates your space.
            </p>
          </div>

          <div>
            <CoreComponent20 content={content100} />
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-4">
            <img src={icon} style={{ width: "75%" }} alt="ruby on rails " />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-sm">
              Experience Raiden’s Ruby on Rails Services
            </h2>
            <p className="mt-4 h1-para lh-base" >
              Raiden, a Ruby on Rails development company, &nbsp;
              has over 10+ years of experience; we are prominent in mobile and
              website services. With a team of proficient Ruby on Rails
              developers, we offer a user-focused website for a visually
              appealing and effective experience. We employ unique technology to
              demonstrate your market leadership and future growth potential.
              Even in a high-concurrency environment, you will have a unique
              experience possible due to our incredibly powerful service and
              detailed solution to your complexities. Our forecasted case
              studies and project showcases allow your customers to visibly
              experience the results of Ruby on Rails development.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <WebDesignCore vertical={vertical} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="mb-4 text-center h2-heading lh-sm">
          Ruby on Rails Development Services
        </h2>
        <p className="mb-40  h1-para lh-base mx-4  text-center" >
          Ruby on Rails (ROR), known as Rails, is a server-based web application
          framework that broadly functions with the Ruby programming language,
          which provides a featured way to organize applications. As an
          experienced company, we deliver Ruby on Rails development, making it a
          powerful choice for developing a range of web applications.
        </p>

        <CoreComponent14 content={content} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="container text-center mt-80 mart">
        <h2 className="h2-heading lh-sm">Mastering the Full Spectrum of Ruby Development </h2>
        <p className="my-3  h1-para lh-base">Excellence and Successful Execution</p>
        <Enterpertises2 />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome /> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default RubyONRailsdevelopment;
